import { useFormContext } from 'react-hook-form';
import LocalizedTexts from '@features/LocalizeItemModal/LocalizedTexts';
import { getSurveyTextFields } from '@helpers/surveyLanguages';

const CustomWording = ({ isView, currentLocale }) => {
    const { watch } = useFormContext();
    const ratingEnabled = watch('satisfactionSurveyEnabled');

    return <LocalizedTexts fields={getSurveyTextFields(ratingEnabled)} currentLocale={currentLocale} isView={isView} />;
};

export default CustomWording;
